var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('stat',{attrs:{"title":_vm.$t('dashboard.gains.title'),"loading":_vm.loading}},[_c('gains-chart',{staticStyle:{"width":"100%"},attrs:{"dataKey":_vm.dataKey,"params":_vm.params,"height":200}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d9f87d6c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/Gains.vue
// module id = null
// module chunks = 